// import http from '../../services/http'

const state = {
  isOpen: false,
  loading: false,
  authState: null,
  lockationId: null
}
const mutations = {
  setIsOpen (state, isOpen) {
    state.isOpen = isOpen
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setAuthState (state, authState) {
    state.authState = authState
  },
  setLocationId (state, locationId) {
    state.lockationId = locationId
  }
}
const getters = {
  getIsOpen (state) {
    return state.isOpen
  },
  getLoading (state) {
    return state.loading
  },
  getAuthState (state) {
    return state.authState
  }
}
const actions = {
  openChat ({ commit, dispatch }) {
    commit('setIsOpen', true)
    // if (!localStorage.getItem('accessToken')) {
    //   commit('setAuthState', 'logedOut')
    //   return
    // }
    //
    // return new Promise((resolve) => {
    //   commit('setLoading', true)
    //   http
    //     .get('/user/me/').then((r) => {
    //       commit('setLoading', false)
    //       commit('setIsOpen', true)
    //       commit('setAuthState', 'loggedIn')
    //       resolve(r.data)
    //     })
    // })
  },
  setLocationId ({ commit }, locationId) {
    if (locationId) {
      localStorage.setItem('locationId', locationId)
    }
  },
  closeChat ({ commit }) {
    localStorage.removeItem('accessToken')
    commit('setIsOpen', false)
    commit('auth/setUserName', null, { root: true })
    commit('messages/resetMessages', null, { root: true })
    commit('setAuthState', 'logedOut')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
